import React, { useState, useEffect } from 'react';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, MenuItem, FormControlLabel, Checkbox,
} from '@material-ui/core';

const FacetEditModal = ({ open, onClose, facet, onSave }) => {
  const localizeMessage = useLocalizedMessage();
  const [formData, setFormData] = useState({
    title: '',
    type: 'string',
    orderNatural: true,
    order: 0,
    sortingMode: 'alphabetical',
  });

  useEffect(() => {
    if (facet) {
      setFormData(facet);
    } else if (open) {
      setFormData({
        title: '',
        type: 'string',
        orderNatural: true,
        order: 0,
        sortingMode: 'alphabetical',
      });
    }
  }, [open, facet]);

  const handleOrderChange = (e) => {
    const raw = e.target.value;
    const value = Number.isFinite(+raw) ? parseInt(raw, 10) : 0;
    setFormData({
      ...formData,
      order: value,
      orderNatural: false,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {facet
          ? localizeMessage('customization.filters.modal.editFacet')
          : localizeMessage('customization.filters.modal.addNewFacet')}
      </DialogTitle>
      <DialogContent>
        <div className="grid gap-4 mt-4">
          <TextField
            label={localizeMessage('customization.filters.modal.label.title')}
            fullWidth
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          />

          <TextField
            select
            label={localizeMessage('customization.filters.modal.label.type')}
            value={formData.type}
            onChange={(e) => setFormData({ ...formData, type: e.target.value })}
            fullWidth
          >
            <MenuItem value="string">{localizeMessage('customization.filters.modal.type.string')}</MenuItem>
            <MenuItem value="number">{localizeMessage('customization.filters.modal.type.number')}</MenuItem>
            <MenuItem value="bool">{localizeMessage('customization.filters.modal.type.bool')}</MenuItem>
            <MenuItem value="color">{localizeMessage('customization.filters.modal.type.color')}</MenuItem>
          </TextField>

          <TextField
            label={localizeMessage('customization.filters.modal.label.position')}
            type="number"
            value={formData.order}
            onChange={handleOrderChange}
            helperText={
              formData.orderNatural
                ? localizeMessage('customization.filters.modal.helperText.natural')
                : (formData.order < 0
                  ? localizeMessage('customization.filters.modal.helperText.fromEnd', { position: Math.abs(formData.order) })
                  : localizeMessage('customization.filters.modal.helperText.manualPosition'))
            }
            inputProps={{ step: 1 }}
            fullWidth
          />

          <FormControlLabel
            control={(
              <Checkbox
                checked={!formData.orderNatural}
                onChange={(e) => {
                  const manual = e.target.checked;
                  setFormData({
                    ...formData,
                    orderNatural: !manual,
                    order: manual ? 0 : formData.order,
                  });
                }}
              />
            )}
            label={localizeMessage('customization.filters.modal.label.manualPositioning')}
          />
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {localizeMessage('common.cancel')}
        </Button>
        <Button onClick={() => onSave(formData)} color="primary">
          {localizeMessage('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FacetEditModal;
